<template>
  <div v-if="open" v-legacy-overlay class="legacy-portfolio-overlay" @click="$emit('click', $event)" @keydown="$emit('keydown', $event)">
    <slot />
  </div>
</template>

<script>
import legacyOverlay from '../directives/legacyOverlay';

// Keep the conditional portal at a component root so Vue retains its insertion
// point when the dialog is removed from its external host and opened again.
export default {
  name: 'LegacyPortfolioOverlay',
  directives: { legacyOverlay },
  props: { open: { type: Boolean, default: false } }
};
</script>
